import { Button, HStack, Icon, Text } from '@chakra-ui/react';
import { PlusIcon } from '@heroicons/react/outline';
import { MenuListProps, chakraComponents } from 'chakra-react-select';
import { useTranslations } from 'use-intl';

import { noop } from '@blockpulse3/data/shared';
import { HoldingMethod } from '@blockpulse3/graphql/hooks';

import { checkFiscalAccountHoldingMethod } from '../../utils';
import { HoldingMethodOption, HoldingMethodOptionGroup } from './types';

type HoldingMethodMenuListProps = MenuListProps<
  HoldingMethodOption,
  false,
  HoldingMethodOptionGroup
> & {
  onClick?: () => void;
  allowedHoldingMethods: HoldingMethod[] | null | undefined;
};

/**
 * MenuList.
 * Custom menu list component, add a link to the settings.
 *
 * @param {HoldingMethodMenuListProps} props
 * @returns {JSX.Element}
 */
export function MenuList({
  onClick = noop,
  allowedHoldingMethods,
  ...props
}: HoldingMethodMenuListProps): JSX.Element {
  const i18nGeneral = useTranslations('General');

  const handleClick = (): void => {
    onClick();
  };

  const isFiscalAccountAllowed = checkFiscalAccountHoldingMethod(allowedHoldingMethods);

  /* ** Prevent adding fiscal account if not allowed by fundraising ** */
  if (!isFiscalAccountAllowed) {
    return <chakraComponents.MenuList {...props} />;
  }

  return (
    <chakraComponents.MenuList {...props}>
      {props.children}
      <HStack height="40px" px="3">
        <Button
          leftIcon={<Icon as={PlusIcon} boxSize="18px" color="gray.600" />}
          variant="link"
          onClick={handleClick}
        >
          <Text fontSize="sm">{i18nGeneral('Add')}</Text>
        </Button>
      </HStack>
    </chakraComponents.MenuList>
  );
}
